import { AuthenticationContext, adalFetch, withAdalLogin } from "react-adal";

let redirecttionURI;
process.env.NODE_ENV === "production" &&
process.env.REACT_APP_RUN_ENV === "production"
	? (redirecttionURI = "https://maestro.insights.maersk.com/")
	: process.env.NODE_ENV === "production" &&
	  process.env.REACT_APP_RUN_ENV === "development"
	? (redirecttionURI = "https://maestro-dev.insights.maersk.com/")
	: (redirecttionURI = "http://localhost:3000/");

let endpoint;
process.env.NODE_ENV === "production" &&
process.env.REACT_APP_RUN_ENV === "production"
	? (endpoint = "a282ff17-428f-4785-8a03-f0c8bab8a936")
  : (endpoint = "1f81039c-50a0-441b-8968-8c9f2abaac4a");
  
export const adalConfig = {
	tenant: "05d75c05-fa1a-42e7-9cf1-eb416c396f2d",
	clientId: endpoint,
	endpoints: {
		api: endpoint, // <-- The Azure AD-protected API
	},
	cacheLocation: "localStorage",
  redirectUri: redirecttionURI,
  system: {
    tokenRenewalOffsetSeconds: 10
  }
};

export const authContext = new AuthenticationContext(adalConfig);

export const adalApiFetch = (fetch, url, options) =>
	adalFetch(authContext, adalConfig.endpoints.api, fetch, url, options);

export const withAdalLoginApi = withAdalLogin(authContext);
